import { supabase } from '../helper/supabaseClient';

export async function trackOfferEvent({
  event_type,
  offer_id,
  brand,
  user_id,
  tier_at_time,
  page_context,
}) {
  try {
    const payload = {
      event_type,
      offer_id,
      brand: brand ?? null,
      user_id: user_id ?? null,
      tier_at_time: tier_at_time ?? null,
      page_context: page_context ?? null,
    };

    console.debug('[analytics] offer event payload:', payload);
    const { data, error } = await supabase.from('offer_events').insert([payload]).select();
    console.debug('[analytics] offer event response:', { data, error });
    if (error) console.debug('[analytics] offer event insert failed:', error.message || error);
  } catch (e) {
    console.debug('[analytics] offer event exception:', e?.message || e);
  }
}

export async function trackCommunityPostEvent({
  event_type,
  post_id,
  brand_name,
  linked_offer_id,
  user_id,
  page_context,
}) {
  try {
    const payload = {
      event_type,
      post_id,
      brand_name: brand_name ?? null,
      linked_offer_id: linked_offer_id ?? null,
      user_id: user_id ?? null,
      page_context: page_context ?? null,
    };

    const { error } = await supabase.from('community_post_events').insert([payload]);
    if (error) console.debug('[analytics] community event insert failed:', error.message || error);
  } catch (e) {
    console.debug('[analytics] community event exception:', e?.message || e);
  }
}

